import DeviceContext from 'contexts/DeviceContext';
import {useContext} from 'react';

export function useIsIPhone() {
    const {device} = useContext(DeviceContext);

    return device?.model === 'iPhone';
}
